import { render, staticRenderFns } from "./tableHeades.vue?vue&type=template&id=78cebcbe&scoped=true&"
import script from "./tableHeades.vue?vue&type=script&lang=js&"
export * from "./tableHeades.vue?vue&type=script&lang=js&"
import style0 from "./tableHeades.vue?vue&type=style&index=0&id=78cebcbe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cebcbe",
  null
  
)

export default component.exports